var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 26,
    viewBox: "0 0 19 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4611 12.3455H16.5885V7.98012H16.5779C16.5804 7.90657 16.5885 7.8348 16.5885 7.7609C16.5885 3.78341 13.3634 0.55835 9.38417 0.55835C5.40881 0.55835 2.18375 3.78341 2.18375 7.7609C2.18375 7.8348 2.19011 7.90657 2.19223 7.98012H2.18375V12.3455H1.30898C0.586246 12.3455 0 12.9314 0 13.6545V24.1326C0 24.8557 0.585892 25.4416 1.30898 25.4416H17.4611C18.1842 25.4416 18.7701 24.8557 18.7701 24.1326V13.6545C18.7705 12.9314 18.1842 12.3455 17.4611 12.3455ZM13.0961 7.98012V12.3455H5.67435V7.98012H5.68708C5.68283 7.90657 5.67435 7.8348 5.67435 7.7609C5.67435 5.71222 7.3355 4.05107 9.38417 4.05107C11.4329 4.05107 13.0961 5.71222 13.0961 7.7609C13.0961 7.8348 13.0898 7.90657 13.0859 7.98012H13.0961Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.114d0534d5cbf9a8d1f0abfd45071f1d.svg";
export { ForwardRef as ReactComponent };